import React, { useState } from 'react';
import styled from 'styled-components';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import RegistrationSuccess from './RegistrationSuccess';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 2rem;
  background-color: #f5f5f5;
`;

const Logo = styled.div`
  font-size: 2.5rem;
  font-weight: bold;
  color: #0084ff;
  margin-bottom: 1rem;
  text-align: center;
`;

const Tagline = styled.div`
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 2rem;
  text-align: center;
`;

const AuthContainer = ({ onAuthenticated }) => {
  // Possible states: 'login', 'register', 'forgotPassword', 'registrationSuccess'
  const [authState, setAuthState] = useState('login');
  const [registeredEmail, setRegisteredEmail] = useState('');
  
  const handleLogin = (user) => {
    // Pass user data and false for isNewRegistration
    onAuthenticated(user, false);
  };
  
  const handleRegister = (user) => {
    // Store the email and show registration success page
    setRegisteredEmail(user.email);
    setAuthState('registrationSuccess');
  };
  
  const handleContinueAfterRegistration = () => {
    // Switch to login page after registration success
    setAuthState('login');
  };
  
  const switchToRegister = () => {
    setAuthState('register');
  };
  
  const switchToLogin = () => {
    setAuthState('login');
  };
  
  const switchToForgotPassword = () => {
    setAuthState('forgotPassword');
  };
  
  return (
    <Container>
      <Logo>AI-Governance</Logo>
      <Tagline>Intelligent Chat with Policy Filtering</Tagline>
      
      {authState === 'login' && (
        <LoginForm 
          onLogin={handleLogin} 
          switchToRegister={switchToRegister}
          switchToForgotPassword={switchToForgotPassword}
        />
      )}
      
      {authState === 'register' && (
        <RegisterForm 
          onRegister={handleRegister} 
          switchToLogin={switchToLogin} 
        />
      )}
      
      {authState === 'forgotPassword' && (
        <ForgotPasswordForm
          switchToLogin={switchToLogin}
        />
      )}
      
      {authState === 'registrationSuccess' && (
        <RegistrationSuccess
          email={registeredEmail}
          onContinue={handleContinueAfterRegistration}
        />
      )}
    </Container>
  );
};

export default AuthContainer;
